export const colonModuleOverview = [
  {
    id: "anatomy",
    title: "Colon Anatomy",
    description: "Learn the structure of the colon",
    icon: "❤️",
    customImage: "module-colon-anatomy.png",
    gradient: "from-green-300 via-green-50 to-rose-100 border-green-500",
  },
  {
    id: "histology",
    title: "Colon Histology",
    description: "Microscopic structure of the colon",
    icon: "🔬",
    customImage: "module-colon-anatomy.png",
    gradient: "from-green-100 via-green-50 to-rose-100 border-green-500",
  },
  {
    id: "physiology",
    title: "Colon Physiology",
    description: "Absorption and motility function",
    icon: "⚡",
    gradient: "from-green-300 via-green-50 to-rose-100 border-green-500",
  },
];
